import axios from 'axios';
import { Env, ENV_VARS } from './config';

export interface GrantToken {
  grant: string;
  grantType: string;
}

export interface AuthToken {
  accessToken: string;
  refreshToken: string;
}

const loginTab = (env: Env): Promise<GrantToken> => {
  const { AUTH_HOST, HOST, CLIENT_ID } = ENV_VARS[env];
  const cognitoUrl = `${AUTH_HOST}/login?redirect_uri=${HOST}/success.html&response_type=code&client_id=${CLIENT_ID}&state=STATE&scope=`;

  const windowArea = {
    width: Math.floor(window.outerWidth * 0.8),
    height: Math.floor(window.outerHeight * 0.5),
    left: 0,
    top: 0,
  };

  if (windowArea.width < 1000) {
    windowArea.width = 1000;
  }
  if (windowArea.height < 630) {
    windowArea.height = 630;
  }
  windowArea.left = Math.floor(window.screenX + (window.outerWidth - windowArea.width) / 2);
  windowArea.top = Math.floor(window.screenY + (window.outerHeight - windowArea.height) / 8);

  const url = cognitoUrl;
  const windowOpts = `toolbar=0,scrollbars=1,status=1,resizable=1,location=1,menuBar=0,
    width=${windowArea.width},height=${windowArea.height},
    left=${windowArea.left},top=${windowArea.top}`;

  const authWindow = window.open(url, '_blank', windowOpts);
  // Create IE + others compatible event handler
  return new Promise((resolve) => {
    const doLogin = (code: string) => {
      const response = {
        grantType: 'authorization_code',
        grant: code,
      };
      resolve(response);
      if (authWindow) {
        authWindow.close();
      }
    };

    //eslint-disable-next-line
    (window as any).login = doLogin;
  });
};

const getToken = async (grantToken: GrantToken, env: Env) => {
  const { AUTH_HOST, HOST, CLIENT_ID } = ENV_VARS[env];
  try {
    const data = {
      code: grantToken.grant,
      grant_type: grantToken.grantType,
      client_id: CLIENT_ID,
      redirect_uri: `${HOST}/success.html`,
    };

    const formBody = [];
    for (const property in data) {
      const encodedKey = encodeURIComponent(property);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const encodedValue = encodeURIComponent(data[property]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    const body = formBody.join('&');

    const response = await axios.post(`${AUTH_HOST}/oauth2/token`, body, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const login = async (env: Env): Promise<boolean> => {
  try {
    const grantToken = await loginTab(env);
    const authToken = await getToken(grantToken, env);
    sessionStorage.setItem('access_token', authToken.access_token);
    localStorage.setItem('refresh_token', authToken.refresh_token);
    localStorage.setItem(
      'storeId',
      JSON.parse(atob(authToken.access_token.split('.')[1])).username
    );
    return true;
  } catch (_err) {
    console.log('Failed to login');
    localStorage.clear();
    return false;
  }
};
